import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import styles from "./CreateTrainingModal.module.scss";
import { useCreateUserTrainingMutation } from "@/store/trainingsApi";

type CreateTrainingModalProps = {
  onClose: () => void;
  initData: string;
  onSuccess: () => void;
  fromUser?: number;
};

export const CreateTrainingModal: React.FC<CreateTrainingModalProps> = ({
  onClose,
  initData,
  onSuccess,
  fromUser,
}) => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [trainingDate, setTrainingDate] = useState<Date | null>(new Date());
  const [muscleGroup, setMuscleGroup] = useState("");

  const [createTraining, { isLoading: isCreatingTraining }] = useCreateUserTrainingMutation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!title.trim()) {
      toast.error("Введите название тренировки");
      return;
    }

    if (!trainingDate) {
      toast.error("Выберите дату тренировки");
      return;
    }

    try {
      // Создаем пустую тренировку
      const trainingResult = await createTraining({
        title: title.trim(),
        training_date: trainingDate.toISOString(),
        muscle_group: muscleGroup.trim() || undefined,
        fromUser: fromUser,
      }).unwrap();

      const trainingId = trainingResult.training_id;

      toast.success("Тренировка создана!");
      onSuccess();
      onClose();
      
      // Перенаправляем на страницу редактирования тренировки
      navigate(`/edit-training/${trainingId}`);
    } catch (error: any) {
      console.error("Ошибка создания тренировки:", error);
      toast.error(error?.data?.detail || "Ошибка при создании тренировки");
    }
  };

  return (
    <>
      <div className={styles.overlay} onClick={onClose}></div>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h2>Создать тренировку</h2>
          <button className={styles.closeBtn} onClick={onClose}>
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.formGroup}>
            <label>Название тренировки</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Например: Тренировка груди"
              className={styles.input}
              required
            />
          </div>

          <div className={styles.formGroup}>
            <label>Дата тренировки</label>
            <DatePicker
              selected={trainingDate}
              onChange={(date) => setTrainingDate(date)}
              dateFormat="dd.MM.yyyy"
              className={styles.datePicker}
              placeholderText="Выберите дату"
              customInput={<input className={styles.input} readOnly />}
            />
          </div>

          <div className={styles.formGroup}>
            <label>Группа мышц (необязательно)</label>
            <input
              type="text"
              value={muscleGroup}
              onChange={(e) => setMuscleGroup(e.target.value)}
              placeholder="Например: Грудь, Спина"
              className={styles.input}
            />
          </div>

          <div className={styles.actions}>
            <button type="button" className={styles.cancelBtn} onClick={onClose}>
              Отмена
            </button>
            <button
              type="submit"
              className={styles.submitBtn}
              disabled={isCreatingTraining}
            >
              {isCreatingTraining ? "Создание..." : "Создать тренировку"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

